export const data = [
  {
    name: 'Галузь гірничо-металургійний комплекс',
    groups: [
      {
        name: 'Чорна металургія',
        criteria: [
          {
            name: 'Чавун, млн. т',
            weight: 7,
            data: [28.9, 45.5, 31.1],
          },
          {
            name: 'Сталь, млн.т',
            weight: 6,
            data: [17.6, 16.6, 18.1],
          },
          {
            name: 'Стальний прокат',
            weight: 6,
            data: [19.5, 18.4, 16.8],
          },
        ],
      },
      {
        name: 'Кольорова металургія',
        criteria: [
          {
            name: 'Руди залізні неагломеровані, млн.т',
            weight: 10,
            data: [173, 176, 155],
          },
          {
            name: 'Концентрати залізорудні неагломеровані, млн.т',
            weight: 9,
            data: [66.5, 67.1, 65.4],
          },
          {
            name: 'Концентрати залізорудні агломеровані, млн.т',
            weight: 8,
            data: [64.4, 64.6, 54.6],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь хімія і фармацевтика',
    groups: [
      {
        name: 'Хімічна промисловість',
        criteria: [
          {
            name: 'Кислота сірчана; олеум, тис.т',
            weight: 10,
            data: [1639, 1454, 1217],
          },
          {
            name: 'Гідроксид натрію (сода каустична) у водному розчині (їдкий натрій або сода рідка), тис.т',
            weight: 8,
            data: [159, 132, 62.9],
          },
          {
            name: 'Фарби та лаки на основі акрилових або вінілових полімерів, у водному середовищі, тис.т',
            weight: 9,
            data: [79.2, 86.2, 89.6],
          },
        ],
      },
      {
        name: 'Фармацевтична промисловість',
        criteria: [
          {
            name: 'Препарати лікарські, що містять пеніцилін та інші антибіотики, т',
            weight: 10,
            data: [955, 939, 1100],
          },
          {
            name: 'Препарати лікарські, що містять  гормони і не містять антибіотики, т',
            weight: 9,
            data: [106, 114, 130],
          },
          {
            name: 'Препарати лікарські, що містять алкалоїди або їх похідні, і не містять гормони чи антибіотики, тис.т',
            weight: 7,
            data: [40.1, 43.4, 49.7],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь машинобудування',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'Автомобілі легкові, тис.шт.',
            weight: 10,
            data: [97.5, 69.7, 45.8],
          },
          {
            name: 'Автобуси, тис.шт.',
            weight: 6,
            data: [3.7, 3.6, 2.6],
          },
          {
            name: 'Автомобілі вантажні, тис.шт.',
            weight: 6,
            data: [3.2, 3.6, 2.6],
          },
          {
            name: 'Причепи та напівпричепи інші для перевезення вантажів (крім житлових або для туризму), тис.шт.',
            weight: 9,
            data: [26.2, 21.7, 29.8],
          },
          {
            name: 'Вагони вантажні та вагони-платформи, залізничні або трамвайні, несамохідні, тис.шт.',
            weight: 8,
            data: [52.7, 47.8, 25.3],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь деревообробна і целюлозно-паперова промисловість',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'Деревина уздовж розпиляна чи розколота, тис.м3',
            weight: 9,
            data: [1888, 1823, 1804],
          },
          {
            name: 'Бруски, планки та фризи для паркетного або дерев’яного покриття підлоги, тис.м2',
            weight: 9,
            data: [3765, 3619, 3563],
          },
          {
            name: 'Вікна та двері з деревини, тис.м2',
            weight: 8,
            data: [2921, 2642, 3309],
          },
          {
            name: 'Папір і картон графічного призначення, тис.т',
            weight: 5,
            data: [33.4, 17.8, 13.7],
          },
          {
            name: 'Папір для виготовлення гігієнічних або косметичних серветок, рушників, пелюшок, скатертин, вата целюлозна і полотно з волокон целюлозних, тис.т',
            weight: 8,
            data: [131, 138, 146],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь товари легкої промисловості',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'Тканини, млн.м2',
            weight: 9,
            data: [89, 105.7, 93.6],
          },
          {
            name: 'Пряжа вовняна, тис.т',
            weight: 4,
            data: [1.7, 1.8, 1.9],
          },
          {
            name: 'Килими та вироби килимові, млн.м2',
            weight: 5,
            data: [7.6, 8.2, 8.5],
          },
          {
            name: 'Взуття, млн. пар',
            weight: 6,
            data: [28.1, 28.3, 30.5],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь енергоносіїв',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'Газ природний скраплений або в газоподібному стані, млрд.м3',
            weight: 6,
            data: [20.7, 20.5, 21.3],
          },
          {
            name: 'Вугілля кам\'яне, млн.т',
            weight: 9,
            data: [62.7, 65.7, 64.2],
          },
          {
            name: 'Нафта сира, у т.ч. нафта, одержана з мінералів бітумінозних, млн.т',
            weight: 5,
            data: [2.4, 2.3, 2.2],
          },
          {
            name: 'Електроенергія, млрд.кВт×год',
            weight: 10,
            data: [194.9, 198.9, 194.4],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь сільського господарства',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'М’ясо великої рогатої худоби свіже чи охолоджене, тис.т',
            weight: 7,
            data: [60.4, 61.8, 62.8],
          },
          {
            name: 'М’ясо свійської птиці свіже чи охолоджене, тис.т',
            weight: 10,
            data: [689, 691, 778],
          },
          {
            name: 'Борошно, тис.т',
            weight: 9,
            data: [2596, 2605, 2542],
          },
          {
            name: 'Крупи, тис.т',
            weight: 8,
            data: [356, 365, 367],
          },
          {
            name: 'Цукор білий кристалічний, тис.т',
            weight: 8,
            data: [2586, 2143, 1263],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь науки та інновації',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'Кількість організації, які виконують наукові дослідження й розробки',
            weight: 9,
            data: [1255, 1208, 1143],
          },
          {
            name: 'Чисельність науковців, осіб',
            weight: 9,
            data: [84969, 82032, 77853],
          },
          {
            name: 'Обсяг виконаних наукових та науково-технічних робіт всього, у фактичних цінах, млн.грн.',
            weight: 5,
            data: [10349.9, 11252.7, 11781.1],
          },
          {
            name: 'Інноваційна активність, загальна сума витрат, млн.грн',
            weight: 6,
            data: [14333.9, 11480.6, 9562.6],
          },
        ],
      },
    ],
  },
  {
    name: 'Галузь туризму',
    groups: [
      {
        name: '',
        criteria: [
          {
            name: 'Кількість громадян України, які виїжджали за кордон – усього, млн.',
            weight: 7,
            data: [19.77, 21.43, 23.76],
          },
          {
            name: 'Кількість іноземних громадян, які відвідали Україну – усього, млн.',
            weight: 8,
            data: [21.41, 23.01, 24.67],
          },
          {
            name: 'Кількість туристів, обслугованих суб\'єктами туристичної діяльності України – усього, млн.',
            weight: 9,
            data: [21.99, 30, 34.54],
          },
        ],
      },
    ],
  },
]
